import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import ProductsSection from "./components/ProductsSection";
import BundlesSection from "./components/BundlesSection";
import IndustrySolutions from "./components/IndustrySolutions";
import TestimonialsSection from "./components/TestimonialsSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#070C18] font-sans">
      <Navbar />
      <main>
        <HeroSection />
        <ProductsSection />
        <BundlesSection />
        <IndustrySolutions />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
